import { navLinks, contactInfo, socialLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-primary-500/25 py-12">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <a href="#hero" className="flex flex-col items-center md:items-start gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden ring-1 ring-primary-500/60 bg-background-50 logo-glow">
              <img
                src="https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/f74a46007c2be116dc4d23be74f0eb02.png"
                alt="Bertie's Restaurant & Cocktails logo"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-center md:text-left">
              <span className="block font-heading text-xl font-semibold text-foreground-50 tracking-wide">
                Bertie&rsquo;s Restaurant &amp; Cocktails
              </span>
              <span className="block text-[10px] uppercase tracking-[0.25em] text-primary-500/80 mt-1">
                {contactInfo.address}
              </span>
            </div>
          </a>

          <nav className="flex flex-wrap justify-center gap-x-7 gap-y-3">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-foreground-200/80 hover:text-primary-500 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-primary-500/40 text-foreground-200 hover:text-primary-500 hover:border-primary-500 transition-colors"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href={socialLinks.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-primary-500/40 text-foreground-200 hover:text-primary-500 hover:border-primary-500 transition-colors"
            >
              <i className="ri-tiktok-line text-lg"></i>
            </a>
            <a
              href={socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="w-10 h-10 flex items-center justify-center rounded-full border border-primary-500/40 text-foreground-200 hover:text-primary-500 hover:border-primary-500 transition-colors"
            >
              <i className="ri-facebook-line text-lg"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 h-px bg-background-300/70"></div>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <span className="text-xs uppercase tracking-[0.25em] px-3 py-1.5 rounded-full border border-primary-500/40 text-primary-500">
            Now Open!
          </span>
          <p className="text-xs text-foreground-200/60 text-center">
            &copy; 2026 Bertie&rsquo;s Restaurant &amp; Cocktails LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}